import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import IndustryOverview from "./sections/IndustryOverview";
import OurValues from "./sections/OurValues";
import PivotDoorProductGrid from "./sections/PivotDoorProductGrid";
import AboutSipo from "./sections/AboutSipo";
import HowDnaTestingWorks from "./sections/HowDnaTestingWorks";
import TestimonialsClientLogos from "./sections/TestimonialsClientLogos";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <IndustryOverview />
      <OurValues />
      <PivotDoorProductGrid />
      <AboutSipo />
      <HowDnaTestingWorks />
      <TestimonialsClientLogos />
      <FinalCallToAction />
      <Footer />
    </div>;
}